import { render } from "./NotFoundPanel.vue?vue&type=template&id=81076ff8&scoped=true"
import script from "./NotFoundPanel.vue?vue&type=script&lang=js"
export * from "./NotFoundPanel.vue?vue&type=script&lang=js"

import "./NotFoundPanel.vue?vue&type=style&index=0&id=81076ff8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81076ff8"]])

export default __exports__